<template>
  <div class="nearby-stay">
    <div class="container">
      <h2 class="page-title blue">{{ title }}</h2>
      <div
        v-swiper:mySwiper="swiperOption(swiperSize)"
        class="swiper-container"
      >
        <div class="swiper-wrapper">
          <kcs-facility-stay-item
            :stay="stay"
            v-for="(stay, index) in stays"
            :key="index"
            @click.native="
              handleAnalyticsTrackEvent(
                'facility_stay',
                'click',
                'stay_link',
                1
              )
            "
          />
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
      <kcs-btn
        :url="url"
        :external="true"
        @click.native="
          handleAnalyticsTrackEvent(
            'facility_stay',
            'click',
            'rakuten_travel_link',
            1
          )
        "
        :nofollow="true"
        name="もっと見る"
      />
      <p class="rakuten-license">
        <!-- Rakuten Web Services Attribution Snippet FROM HERE -->
        <a
          href="https://webservice.rakuten.co.jp/"
          target="_blank"
          rel="nofollow"
          ><img
            src="https://webservice.rakuten.co.jp/img/credit/200709/credit_22121.gif"
            border="0"
            alt="楽天ウェブサービスセンター"
            title="楽天ウェブサービスセンター"
            width="221"
            height="21"
        /></a>
        <!-- Rakuten Web Services Attribution Snippet TO HERE -->
      </p>
    </div>
  </div>
</template>

<script>
import { methods } from '@/utils/methods'
import KcsFacilityStayItem from '~/components/molecules/kcs-facility-stay-item.vue'
import kcsBtn from '@/components/atoms/kcs-btn.vue'
export default {
  components: {
    KcsFacilityStayItem,
    kcsBtn
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
    stays: {
      type: Array,
      required: true
    },
    isSmallGallery: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title() {
      return this.detail.name + '周辺のおすすめホテル・旅館（宿泊施設）'
    },
    swiperSize() {
      return this.isSmallGallery ? 4 : 3
    },
    url() {
      return (
        'https://search.travel.rakuten.co.jp/ds/undated/search?' +
        'f_km=3.0' +
        '&f_tab=hotel' +
        '&f_latitude=' +
        this.detail.lat +
        '&f_longitude=' +
        this.detail.lng
      )
    }
  },
  methods: {
    swiperOption(size) {
      return methods.swiperOption(size)
    }
  }
}
</script>
